import "./SingleProductTemplate.module.css"
import TrendMitraNavigationHeader from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import TerminalFooter from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <TrendMitraNavigationHeader />
      <SingleProductTemplateSection />
      <TerminalFooter />
    </div>
  )
}
